var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMayaOriginal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "maya-original-a",
    gradientUnits: "userSpaceOnUse",
    x1: 100.777,
    y1: 85.094,
    x2: 86.576,
    y2: 91.058
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#1A5964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#137078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0E8085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0C858A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A8B8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "maya-original-b",
    gradientUnits: "userSpaceOnUse",
    x1: 99.581,
    y1: 56.123,
    x2: 130.166,
    y2: 75.523
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#079EA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#14878E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#256A77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "maya-original-c",
    gradientUnits: "userSpaceOnUse",
    x1: 112,
    y1: 16.835,
    x2: 112,
    y2: 120.497
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#03ABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#137980"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "maya-original-d",
    gradientUnits: "userSpaceOnUse",
    x1: 59.349,
    y1: 57.417,
    x2: 135.485,
    y2: 42.575
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0F5D64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#097A7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#049395"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#01A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#00A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4EBCC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "maya-original-e",
    gradientUnits: "userSpaceOnUse",
    x1: -10.003,
    y1: 72.033,
    x2: 26.772,
    y2: 50.748
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#049496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088286"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "maya-original-f",
    gradientUnits: "userSpaceOnUse",
    x1: 2.06,
    y1: 91.643,
    x2: 32.014,
    y2: 89.985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20626E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#069D9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "maya-original-g",
    gradientUnits: "userSpaceOnUse",
    x1: 41.036,
    y1: 5.266,
    x2: 36.336,
    y2: 101.578
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#99CBD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#498F93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E7B7D"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#maya-original-a)",
    d: "M98 121h3V49l-6 9v56l3 7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#maya-original-b)",
    d: "M98 121V51l23-44h5v54l-22 60h-6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#maya-original-c)",
    d: "M126 121H98c2.9-5.7 14.1-29.2 19-48 8.5-33.1 9-58 9-58v106z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#maya-original-d)",
    d: "M126 7H89L63 69l11 30h1c.4 0 1-.3 2-2 4.1-7.6 49-90 49-90z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#maya-original-e)",
    d: "M2 121.7l3-.7 27-49V56L5 9 2 7.4v114.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#maya-original-f)",
    d: "M32 59.1c-2.3 6.9-7.9 23.6-13.6 34.3C8.2 113 2 121.7 2 121.7s23.7 2 30-5.7V60v-.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#maya-original-g)",
    d: "M52 97c1 1.8 1.6 2 2 2h21c.2-.2.4-.4.4-.7-.1-.4-.2-.9-.4-1.3L38 4 2 7.4S47.7 89.2 52 97z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMayaOriginal);
export default __webpack_public_path__ + "static/media/maya-original.424d6a6a5f28e2fd2f7b00b299b4ae1f.svg";
export { ForwardRef as ReactComponent };